import { AddRequirementData } from "../addRequirement/data/AddRequirement.data";
import { RequirementListingData } from "../data/RequirementListingData";

export const setAllDropDownField = (apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }

    const dropdownLists = {
        "channel": filterDropDownList("Channel"),
        "requirementSection": filterDropDownList("Requirement Section"),
        "statusId": filterDropDownList("Requirement Section Status"),
    };

    const formFields = [...RequirementListingData.formFields,...AddRequirementData.formFields];

    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });
};